import SrFile from "./SrFile.vue";

SrFile.install = function(Vue) {
  Vue.component(SrFile.name, SrFile);
};

export default SrFile;



// WEBPACK FOOTER //
// ./packages/SrFile/index.js